import BoardList from "@/components/BoardList";
import { getFavoriteBoards } from "@/services";
import pvTracker from "@/tracker/report/pvTracker";
import getPageData from "@/tracker/shared/getPageData";
import useRequest from "@/utils/useReq";
import { useSetState } from "ahooks";
import { useRouter } from "next/router";
import { useCallback, useEffect, useRef, useState } from "react";
import { Else, If, Then } from "react-if";
import styles from "./index.module.less";

export default function FavoriteBoardList({ serverBoardList }) {
  const router = useRouter();
  const { urlname } = router.query;

  const [query, setQuery] = useSetState({
    max: serverBoardList?.length
      ? serverBoardList[serverBoardList.length - 1]?.seq ||
        serverBoardList[serverBoardList.length - 1]?.board_id
      : 0,
    urlname: null,
  });
  const [hasMore, setHasMore] = useState(true);
  const [dataSource, setDataSource] = useState(serverBoardList || []);

  const initRef = useRef(!serverBoardList);
  useRequest(
    async () => {
      const { max, urlname } = query;

      if (!urlname) {
        return;
      }

      const result = await getFavoriteBoards({
        urlname,
        limit: 20,
        ...(max ? { max } : null),
      });

      const boards = result?.boards || [];

      if (boards.length <= 0) {
        setHasMore(false);
      }

      setDataSource(dataSource.concat(boards));
    },
    {
      refreshDeps: [query],
    }
  );

  useEffect(() => {
    if (urlname) {
      setHasMore(true);
      if (initRef.current) {
        setDataSource([]);
        setQuery({
          urlname,
          max: 0,
        });
      } else {
        initRef.current = true;
        setQuery({
          urlname,
        });
      }
    }
  }, [urlname, setQuery]);

  const onLoadMore = useCallback(() => {
    if (dataSource.length > 0) {
      const last = dataSource[dataSource.length - 1];
      setQuery({
        max: last.seq || last.board_id,
      });
      pvTracker(getPageData());
    }
  }, [dataSource, setQuery]);

  return (
    <div className={styles.board}>
      <If condition={dataSource.length > 0 || hasMore}>
        <Then>
          <BoardList
            dataSource={dataSource}
            hasMore={hasMore}
            onLoadMore={onLoadMore}
          />
        </Then>
        <Else>
          <div className={styles.empty}>暂无画板</div>
        </Else>
      </If>
    </div>
  );
}
